/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
export type IShipmentMissingInfoFragment = { __typename?: 'Shipment' } & Pick<
  Types.IShipment,
  'id' | 'marketplaceId' | 'missingInfo' | 'missingInfoUrgencyMessage'
> & {
    stops: Array<
      { __typename?: 'Stops' } & Pick<
        Types.IStops,
        'id' | 'displayTimezone' | 'stopType' | 'stopSequence' | 'startAt' | 'endAt'
      > & {
          address: { __typename?: 'Address' } & Pick<Types.IAddress, 'locality' | 'subdivisionCode'>
        }
    >
  }

export const ShipmentMissingInfoFragmentDoc = gql`
  fragment ShipmentMissingInfo on Shipment {
    id
    marketplaceId
    missingInfo
    missingInfoUrgencyMessage
    stops {
      id
      displayTimezone
      stopType
      stopSequence
      startAt
      endAt
      address {
        locality
        subdivisionCode
      }
    }
  }
`
